<template>
  <div>
    <!-- <div class="pa-6 bg-custom">
      <h2 class="mb-4">
        {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.whocansee') }}
      </h2> -->

    <!-- </div> -->
    <div class="pt-2 pb-0 pl-5 pr-8 bg-white">
      <v-sheet color="white" class="mb-2 pt-2 pb-0 pa-6">
        <v-row no-gutters>
          
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-row v-on="on" no-gutters>
                  <v-col xl="6" cols="5">
                    <v-switch
                      v-model="activeStatus"
                      @change="openModalStatus()"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </template>
              <span v-if="activeStatus">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.stepCourse.clickToSuspend'
                )
              }}</span>
              <span v-else>{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.stepCourse.clickToActivate'
                )
              }}</span>
            </v-tooltip>
          </div>
          <div class="pt-4">
            <span class="green--text text--lighten-1" v-if="activeStatus">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.stepCourse.courseActivated'
              )
            }}</span>
            <span class="red--text text--lighten-2" v-else>{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.stepCourse.courseSuspended'
              )
            }}</span>
          </div>
          
          <v-spacer />
          <div class="pt-4">
            <v-btn
              @click="goToCourseReport"
              elevation="0"
              class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
            >
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseReport.report'
                )
              }}
            </v-btn>
          </div>
        </v-row>
      </v-sheet>
      <v-tabs v-model="tab" show-arrows grow>
        <v-tab
          href="#detail"
          class="subtitle-1 tab-live px-12 uppercast-unset"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.courseDetail')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#lecture"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.lecture')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#live"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.live')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#certificate"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.certificate')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#whocansee"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.whocansee')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#bundle"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.bundle')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#role"
          :disabled="this.$route.query.id == undefined"
          >{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.role')
          }}</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          href="#access"
          :disabled="this.$route.query.id == undefined"
        >
          <v-badge dot :color="learnerRequest != 0 ? 'red' : 'transparent'">
            <span slot="default">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.stepCourse.learnerManagement'
              )
            }}</span>
          </v-badge>
        </v-tab>
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item value="detail">
        <div v-if="tab == 'detail'">
          <detail :changeTab.sync="changeTab" />
        </div>
      </v-tab-item>

      <v-tab-item value="lecture">
        <div v-if="tab == 'lecture'">
          <lecture />
        </div>
      </v-tab-item>
      <v-tab-item value="live">
        <live />
      </v-tab-item>
      <v-tab-item value="certificate">
        <div v-if="tab == 'certificate'">
          <certificate />
        </div>
      </v-tab-item>
      <v-tab-item value="whocansee">
        <whocansee />
      </v-tab-item>
      <v-tab-item value="bundle">
        <bundle />
      </v-tab-item>
      <v-tab-item value="role">
        <div v-if="tab == 'role'">
          <role-tab />
        </div>
      </v-tab-item>
      <v-tab-item value="access">
        <accessment :updateLearnerRequest.sync="updateLearnerRequest" />
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialogUnActiveCourse" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.confirmUnpublish'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.unpublishDescript'
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="grey darken-1"
            outlined
            @click="cancelModalStatus()"
            >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="error darken-1"
            @click="courseActive()"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogActiveCourse" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.confirmPublish'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseList.publishDescript'
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="grey darken-1"
            outlined
            @click="cancelModalStatus()"
            >{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 button-primary font-weight-light"
            dark
            @click="courseActive()"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCantPublic" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.failedToSave')
          }}
        </v-card-title>
        <v-card-text>{{ messageCantPublic }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="grey darken-1" dark rounded outlined @click="dialogCantPublic = false">ยกเลิก</v-btn> -->
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="error darken-1"
            @click="dialogCantPublic = false"
            >{{ $vuetify.lang.t('$vuetify.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.stepCourse.saveSuccess')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.stepCourse.YouCanEditStatusLater'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t('$vuetify.courseManagement.stepCourse.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- <div class="pa-0 ma-1 mb-5 font-weight-light"> -->
  <!--<v-stepper alt-labels v-model="current" class="pa-4">
      <v-stepper-header class="header-card pa-2">
     
          <v-stepper-step
            class="step-custom"
            :complete="this.$route.query.id"
            step="1"
            :color="current == 1 ? (this.$route.query.id) ?'green' : 'primary' : 'primary'"
            :editable="true"
            @click="changeStep(1)"
            edit-icon="mdi-file-document-box"
          >{{$vuetify.lang.t('$vuetify.courseManagement.stepCourse.courseDetail')}}</v-stepper-step>
          <v-divider ></v-divider>
          <v-stepper-step
            class="step-custom"
            :complete="this.$route.query.id"
            step="2"
            :editable="this.$route.query.id"
            :color="current == 2 ? 'green' : 'primary'"
            @click="changeStep(2)"
            edit-icon="mdi-shopping"
          >{{$vuetify.lang.t('$vuetify.courseManagement.stepCourse.bundle')}}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="step-custom"
            :complete="this.$route.query.id"
            step="3"
            :editable="this.$route.query.id"
            :color="current == 3 ? 'green' : 'primary'"
            @click="changeStep(3)"
            edit-icon="mdi-format-list-bulleted-type"
          >{{$vuetify.lang.t('$vuetify.courseManagement.stepCourse.lecture')}}</v-stepper-step>
          <v-divider></v-divider>
           <v-stepper-step
            class="step-custom"
            :complete="this.$route.query.id"
            step="4"
            :editable="this.$route.query.id"
            :color="current == 4 ? 'green' : 'primary'"
            @click="changeStep(4)"
            edit-icon="mdi-video"
          >{{$vuetify.lang.t('$vuetify.courseManagement.stepCourse.live')}}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="step-custom"
            :complete="this.$route.query.id"
            :color="current == 5 ? 'green' : 'primary'"
            step="5"
            :editable="this.$route.query.id"
            @click="changeStep(5)"
            edit-icon="mdi-lan"
          >{{$vuetify.lang.t('$vuetify.courseManagement.stepCourse.access')}}</v-stepper-step>
     
      </v-stepper-header>

      <v-stepper-items  class="pa-3 mt-5">
        <v-stepper-content step="1">
          <detail v-if="current==1" />
        </v-stepper-content>
        <v-stepper-content step="2">
          <bundle v-if="current==2" />
        </v-stepper-content>
        <v-stepper-content step="3">
          <lecture v-if="current==3" />
        </v-stepper-content>
        <v-stepper-content step="4">
          <live v-if="current==4" />
        </v-stepper-content>
            <v-stepper-content step="5">
          <accessment v-if="current==5" />
        </v-stepper-content>
      </v-stepper-items>
  </v-stepper>-->
  <!-- </div> -->
</template>
<script>
import { getCourseById, updateActive } from '@/service/course/course';
import detail from '@/views/course/detail.vue';
import lecture from '@/views/course/lecture.vue';
import { getRoom } from '@/service/room/room';
import { getLive } from '@/service/course/live';
import accessment from '@/views/course/accessment/accessment.vue';
import live from '@/views/course/live_new.vue';
// import live from '@/views/course/live.vue';
import certificate from '@/views/course/certificate.vue';
import whocansee from '@/views/course/whocansee.vue';
import bundle from '@/views/course/bundle.vue';
import role from '@/views/course/role.vue';
export default {
  components: {
    detail,
    lecture,
    accessment,
    live,
    bundle,
    'role-tab': role,
    certificate,
    whocansee,
  },
  data() {
    return {
      // current: 1,
      tab: 'detail',
      id_course: null,
      learnerRequest: 0,
      activeStatus: false,
      staticActiveStatus: false,
      dialogActiveCourse: false,
      dialogUnActiveCourse: false,
      dialogCantPublic: false,
      messageCantPublic: '',

      dialogSuccess: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    tab(value) {
      if (this.id_course == undefined || this.id_course == null) {
        this.id_course =
          this.$route.query.id != null && this.$route.query.id != undefined
            ? this.$route.query.id
            : this.id_course;
      }
    },
  },
  methods: {
    async init() {
      this.id_course = this.$route.query.id;
      if (this.id_course != null && this.id_course != undefined) {
        let params = {
          id: this.id_course,
        };
        await this.getCourseDetail(params);
      }

      if (this.$route.query.id) {
        this.tab = 'detail';
      }

      //exam
      if (this.$route.query.tab) {
        this.tab = this.$route.query.tab;
      }

      let requestArr = this.$store.state.requestData;
      requestArr.forEach((request) => {
        if (request._id == this.id_course) {
          this.learnerRequest = request.totalLearner;
        }
      });
    },
    updateLearnerRequest() {
      this.learnerRequest = 0;
      let requestArr = this.$store.state.requestData;
      requestArr.forEach((request) => {
        if (request._id == this.id_course) {
          this.learnerRequest = request.totalLearner;
        }
      });
    },
    changeTab(tabValue) {
      this.tab = tabValue;
    },
    async getCourseDetail(params) {
      let detail = await getCourseById(params);
      console.log(detail);
      this.activeStatus = detail.active;
      this.staticActiveStatus = detail.active;
    },
    openModalStatus() {
      if (this.activeStatus) {
        this.dialogActiveCourse = true;
      } else {
        this.dialogUnActiveCourse = true;
      }
    },
    cancelModalStatus() {
      this.dialogUnActiveCourse = false;
      this.dialogActiveCourse = false;
      this.activeStatus = !this.activeStatus;
    },
    async courseActive() {
      if (this.activeStatus) {
        let canPublicCourseStatus = await this.canPublicCourse();
        if (!canPublicCourseStatus) {
          this.cancelModalStatus();
          this.dialogCantPublic = true;
          return;
        }
      }
      let status = await updateActive({
        id: this.id_course,
        active: this.activeStatus,
      });

      this.dialogUnActiveCourse = false;
      this.dialogActiveCourse = false;

      if (status) {
        this.dialogSuccess = true;
      }
    },
    async canPublicCourse() {
      let resultCourseDetail = await getCourseById({
        id: this.id_course,
      });
      let resultRoom = await getRoom({
        idcourse: this.id_course,
      });

      let resultLive = await getLive({
        idcourses: this.id_course,
      });

      if (
        resultRoom.length <= 0 ||
        resultRoom.filter((room) => room.active == true).length <= 0
      ) {
        this.messageCantPublic =
          'คอร์สเรียนต้องมีกลุ่มห้องเรียนที่เปิดอย่างน้อย 1 กลุ่ม';
        return false;
      } else if (
        resultCourseDetail.sections.length > 0 &&
        resultCourseDetail.sections[0].lectures.length <= 0 &&
        resultLive.filter((live) => live.active == true).length <= 0
      ) {
        this.messageCantPublic =
          'บทเรียนต้องมีเนื้อหาอย่างน้อย 1 บท หรือมีการถ่ายทอดสดอย่างน้อย 1 ครั้ง';
        return false;
      } else if (resultCourseDetail.sections.length <= 0) {
        this.messageCantPublic = 'ไม่มีบทเรียน';
        return false;
      } else {
        return true;
      }
    },
    goToCourseReport() {
      this.$router.push({
        path: '/course/report',
        query: {
          id: this.id_course,
        },
      });
    }
    // changeStep(n) {
    //   if (this.$route.query.id) {
    //     this.$router.push({
    //       path: "/course/detail",
    //       query: { id: this.$route.query.id, step: n }
    //     });
    //   }
    // }
  },
};
</script>
<style >
.v-tabs-slider-wrapper {
  height: 0 !important;
}
.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.header-card {
  box-shadow: none;
  transition: transform 0.3s ease-in-out;
  border: 1px solid #e0e0e0;
}
.v-stepper__step__step {
  width: 33px;
  height: 33px;
}
@media only screen and (max-width: 959px) {
  .step-custom > .v-stepper__label {
    display: inline-block !important;
  }
  .step-custom > .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: inline-block !important;
  }
}
</style>
<style scoped>
.v-tabs-slider-wrapper {
  height: 0 !important;
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.position-relative {
  position: relative;
}
.colon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}
.v-tab--active {
  background: #fff !important;
  color: #009bde;
}
.uppercast-unset {
  text-transform: unset;
}
.bg-white {
  background: #fff;
}
</style>